/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface PerformanceMetricRanking
 */
export interface PerformanceMetricRanking {
  /**
   *
   * @type {number}
   * @memberof PerformanceMetricRanking
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceMetricRanking
   */
  metric: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceMetricRanking
   */
  rank: number;
}

/**
 * Check if a given object implements the PerformanceMetricRanking interface.
 */
export function instanceOfPerformanceMetricRanking(value: object): value is PerformanceMetricRanking {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('metric' in value) || value['metric'] === undefined) return false;
  if (!('rank' in value) || value['rank'] === undefined) return false;
  return true;
}

export function PerformanceMetricRankingFromJSON(json: any): PerformanceMetricRanking {
  return PerformanceMetricRankingFromJSONTyped(json, false);
}

export function PerformanceMetricRankingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerformanceMetricRanking {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    metric: json['metric'],
    rank: json['rank'],
  };
}

export function PerformanceMetricRankingToJSON(value?: Omit<PerformanceMetricRanking, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    metric: value['metric'],
    rank: value['rank'],
  };
}
